import { render } from "./ui-ribbon.vue?vue&type=template&id=484888c0"
import script from "./ui-ribbon.vue?vue&type=script&lang=js"
export * from "./ui-ribbon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__